import React from "react";
import { GuestCounterInterface } from "./types";
import assets from "../../assets";
import { StyledGuestCounter } from "./styles";
import { FlexDiv } from "../../components";

const GuestCounter = ({
  adults,
  children = 0,
  onGuestChange,
  maxGuests,
}: GuestCounterInterface) => {
  const handleChange = (type: "adults" | "children", increment: number) => {
    if (type === "adults") {
      const newValue = adults + increment;
      if (newValue >= 1 && newValue <= maxGuests) {
        onGuestChange({ adults: newValue, children });
      }
    } else {
      const newValue = children + increment;
      if (newValue >= 0 && newValue <= maxGuests) {
        onGuestChange({ adults, children: newValue });
      }
    }
  };

  return (
    <StyledGuestCounter>
      <p>
        This place has a maximum capacity of {maxGuests} guests, not including
        infants.
      </p>
      <FlexDiv style={{ margin: "20px 0" }} justifycontent="space-between">
        <div>
          <strong>Adults</strong>
          <p>Ages 13 or above</p>
        </div>
        <FlexDiv alignitems="center" gap="8px">
          <button
            onClick={() => handleChange("adults", -1)}
            disabled={adults <= 1}
            className="counter-button"
            aria-label="Decrease adults"
          >
            <img
              src={assets.minusIcon}
              height={20}
              alt="decrement guestsicon"
            />
          </button>
          <span style={{ width: 20, textAlign: "center" }}>{adults}</span>
          <button
            onClick={() => handleChange("adults", 1)}
            disabled={adults >= maxGuests}
            className="counter-button"
            aria-label="Increase adults"
          >
            <img
              src={assets.plusIcon}
              height={20}
              alt="increment guests icon"
            />
          </button>
        </FlexDiv>
      </FlexDiv>

      {/* Children Counter */}
      <FlexDiv style={{ margin: "20px 0" }} justifycontent="space-between">
        <div>
          <strong>Children</strong>
          <p>Ages 2 – 12</p>
        </div>
        <FlexDiv alignitems="center" gap="8px">
          <button
            onClick={() => handleChange("children", -1)}
            disabled={children <= 0}
            className="counter-button"
            aria-label="Decrease children"
          >
            <img
              src={assets.minusIcon}
              alt="decrement guests icon"
              height={20}
            />
          </button>
          <span style={{ width: 20, textAlign: "center" }}>{children}</span>
          <button
            onClick={() => handleChange("children", 1)}
            disabled={children >= maxGuests}
            className="counter-button"
            aria-label="Increase children"
          >
            <img
              src={assets.plusIcon}
              height={20}
              alt="increment guests icon"
            />
          </button>
        </FlexDiv>
      </FlexDiv>
    </StyledGuestCounter>
  );
};

export default GuestCounter;
